import GenericTable from '../../../../../cars/components/V3/_shared/GenericTable/GenericTable'
import { TableMobileCardContent } from '../../../../../cars/components/V3/_shared/GenericTable/TableMobileCardContent'
import { formatCurrency } from '../../../utils/formatCurrency'
import tollReportDetailsColumns from './tollReportDetailsColumns'
import { useNavigate } from 'react-router-dom'
import type { TollReportDetails } from '../../../../../../types'
import type { Row } from '@tanstack/react-table'
import { formatNumber } from '../../../utils/formatNumber'

type TollReportDetailsTableProps = {
  data: any
  isLoading?: boolean
  options: { year: string; month: string }
}

function TollReportDetailsTable({ data, isLoading, options }: TollReportDetailsTableProps) {
  const columns = tollReportDetailsColumns({ options })

  return (
    <GenericTable
      className="max-h-[50vh]"
      data={data}
      columns={columns}
      isLoading={isLoading}
      mobileCardContent={(row) => {
        return <MobileCardContent row={row} options={options} />
      }}
    />
  )
}

export default TollReportDetailsTable

function MobileCardContent({
  row,
  options,
}: {
  row: Row<TollReportDetails>
  options: { year: string; month: string }
}) {
  const navigate = useNavigate()

  const header = row.original?.regNo || row.original?.vehicleID
  const data = [
    {
      label: 'Objekt',
      value: row.original.carDescription || '',
    },
    {
      label: 'Fakturagruppe',
      value: row.original.invoiceGroupingDescription || '',
    },
    {
      label: 'Beløp',
      value: formatCurrency(row.original.amountIncVat),
    },
    {
      label: 'Kjøretøy-ID',
      value: row.original.vehicleID || '',
    },
    {
      label: 'Sjåfør',
      value: row.original.driverName || '',
    },
    {
      label: 'Antall passeringer',
      value: formatNumber(row.original.antallPasseringer),
    },
  ]

  const action = {
    onClick: () => {
      navigate(`/reports/toll/${options.year}-${options.month}/${row.original.accountNo}?regNo=${row.original.regNo}`)
    },
  }

  return <TableMobileCardContent header={header} data={data} action={action} />
}
